import { render, staticRenderFns } from "./NotifyLoader.vue?vue&type=template&id=84e53d88&scoped=true&"
import script from "./NotifyLoader.vue?vue&type=script&lang=js&"
export * from "./NotifyLoader.vue?vue&type=script&lang=js&"
import style0 from "./NotifyLoader.vue?vue&type=style&index=0&id=84e53d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e53d88",
  null
  
)

export default component.exports